"use client";

import { ReportForm } from "@/features/report-form";
import { ReactNode, useState } from "react";
import {
  Text,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogBody,
} from "@/shared/ui/core";
import styles from "./report-dialog.module.scss";

interface ReportDialogProps {
  trigger: ReactNode;
  your_email?: string;
}

export function ReportDialog({
  trigger,
  your_email,
}: ReportDialogProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>

      <DialogContent>
        <DialogHeader className={ styles.dialog_header }>
          <DialogTitle>
            <Text as="span" variant="heading" weight="semibold">
              Report your incident
            </Text>
          </DialogTitle>

          <DialogDescription>
            <Text as="span" size="lg" tone="secondary">
              On this panel users have the option to report email accounts that
              appear to be suspicious or proven to be fake. carriercheck® will
              investigate the data and might contact you for additional details.
              In case information is validated the incident will be added to our
              database that would help preventing other members from fraudulent
              activiites.
            </Text>
          </DialogDescription>
        </DialogHeader>

        <DialogBody>
          <ReportForm
            your_email={your_email}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
